export function dayKey(iso, tz) {
  if (!iso) return '';
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(iso));
  } catch (_) {
    return String(iso).slice(0, 10);
  }
}

export function dayLabel(iso, tz, now = Date.now()) {
  const key = dayKey(iso, tz);
  const today = dayKey(new Date(now).toISOString(), tz);
  if (key && key === today) return 'Today';
  const yesterday = dayKey(new Date(now - 86400000).toISOString(), tz);
  if (key && key === yesterday) return 'Yesterday';
  try {
    return new Intl.DateTimeFormat(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: tz,
    }).format(new Date(iso));
  } catch (_) {
    return key;
  }
}

export function bubbleTime(iso, tz) {
  if (!iso) return '';
  try {
    return new Intl.DateTimeFormat(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      timeZone: tz,
    }).format(new Date(iso));
  } catch (_) {
    return '';
  }
}

export function listTime(iso, tz, now = Date.now()) {
  if (!iso) return '';
  const key = dayKey(iso, tz);
  const today = dayKey(new Date(now).toISOString(), tz);
  if (key && key === today) return bubbleTime(iso, tz);
  try {
    return new Intl.DateTimeFormat(undefined, {
      day: 'numeric',
      month: 'short',
      timeZone: tz,
    }).format(new Date(iso));
  } catch (_) {
    return key;
  }
}

function reactionKeys(message) {
  return [message?.bp_message_id, message?.id].filter(Boolean).map(String);
}

/**
 * Reaction events are separate bubbles from the wrapper.
 * WhatsApp draws them on the message they point at.
 */
export function foldThreadMessages(messages) {
  const list = Array.isArray(messages) ? messages : [];
  const byTarget = new Map();
  const visible = [];

  list.forEach((message) => {
    if (String(message?.type || '').toLowerCase() === 'reaction') {
      const target = message.reaction?.target_id;
      if (!target) return;
      const key = String(target);
      const direction = message.direction === 'out' ? 'out' : 'in';
      const current = (byTarget.get(key) || []).filter((item) => item.direction !== direction);
      const emoji = String(message.reaction?.emoji || '');
      if (emoji) current.push({ emoji, direction, id: message.id });
      byTarget.set(key, current);
      return;
    }
    visible.push(message);
  });

  return visible.map((message) => {
    const reactions = [];
    const seen = new Set();
    reactionKeys(message).forEach((key) => {
      (byTarget.get(key) || []).forEach((item) => {
        const sig = `${item.direction}:${item.emoji}`;
        if (seen.has(sig)) return;
        seen.add(sig);
        reactions.push(item);
      });
    });
    return { ...message, reactions };
  });
}

export function reactionBadge(reactions) {
  const counts = new Map();
  (reactions || []).forEach((item) => {
    if (!item?.emoji) return;
    counts.set(item.emoji, (counts.get(item.emoji) || 0) + 1);
  });
  return [...counts.entries()];
}
